import type { StyleObject } from 'styletron-standard'
import { RAIL_EASE } from '@/shared/theme/railSlot'

export const riseIn = {
  from: { opacity: 0, transform: 'translateY(8px)' },
  to: { opacity: 1, transform: 'none' },
}

export const popIn = {
  from: { opacity: 0, transform: 'scale(0.5)' },
  to: { opacity: 1, transform: 'none' },
}

export const enter = (
  keyframes: StyleObject['animationName'],
  durationMs: number,
  delay: string = '0ms',
  easing: string = RAIL_EASE,
): StyleObject => ({
  animationName: keyframes,
  animationDuration: `${durationMs}ms`,
  animationDelay: delay,
  animationTimingFunction: easing,
  animationFillMode: 'backwards',
  '@media (prefers-reduced-motion: reduce)': { animationName: 'none' },
})
